import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';

@inject('ticketStore')
@observer
export default class TicketModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInitiated: false
    }
  }

  useGroupBtns = (isGroupBtns) => {
    const {
      ticketStore: {
        controlModal,
        usedControlModal,
        useTickets,
      },
    } = this.props;

    if (isGroupBtns) {
      return (
        <div className="group-button">
          <button type="submit" className="btn-modal" onClick={useTickets}>사용</button>
          <button type="cancel" className="btn-modal" onClick={() => {controlModal(false)}}>취소</button>
        </div>
      )
    }

    return (
      <button type="button" className="btn-modal" onClick={usedControlModal}>확인</button>
    )
  }

  getTicketCountInfo = () => {
    const {
      ticketStore: {
        getAvailableTickets
      },
    } = this.props;

    const {
      checkedTickets
    } = getAvailableTickets();

    const labelObj = {};
    _.forEach(checkedTickets, (ticket) => {
      const label = ticket.itemAgeTypeLable;
      if(!labelObj[label]) {
        labelObj[label] = 1;
      } else {
        labelObj[label] += 1;
      }
    });

    const labelObjKeys = Object.keys(labelObj);
    let labelInfoStr = '';
    _.forEach(labelObjKeys, (key, index) => {
      labelInfoStr += `${key} ${labelObj[key]}장 `
      if(labelObjKeys.length > index + 1) {
        labelInfoStr += '/ ';
      }
    });

    return labelInfoStr;
  }

  renderAllSelectedPopup = () => {
    const {
      ticketStore: {
        isOpenModal,
        useTicketStateMessage
      },
    } = this.props;

    const ticketInfoStr = this.getTicketCountInfo();

    const message = `<div class='txt-title'>${ticketInfoStr}</div>
    현장직원이 아니라면 <span class="txt-title--cancel">'취소'</span>를 눌러주세요!<br /><br />
    전체 티켓을 <span class="txt-title--use">사용</span>하시겠습니까?<br />
    부분 사용시 취소를 눌러서 선택해주세요<br />
    <div class="modal-notice">
      * 고객임의로 사용버튼을 누를 시,<br />
      티켓은 복원이 불가능하오니 사용은 반드시 <br />
      현장직원만 진행해 주십시오.
    </div>`;

    const modalMsg = useTicketStateMessage || message;
    const modalBtns = this.useGroupBtns(!useTicketStateMessage);

    return (
      <div className={`App-modal ${isOpenModal ? 'modal-open' : null}`}>
        <div className="box-modal">
          <p className="txt-modal" dangerouslySetInnerHTML={ {__html: modalMsg} } />
          {modalBtns}
        </div>
      </div>
    )
  }

  renderReselectedPopup() {
    const {
      ticketStore: {
        isOpenModal,
        useTicketStateMessage
      },
    } = this.props;

    const message = `티켓을 <span class="txt-use">사용</span>하시겠습니까?<br />
    현장직원이 아니라면 <span class="txt-cancel">취소</span>를 눌러주세요.<br />
    <div class="modal-notice">
      <br />
      고객임의로 사용버튼을 누를 시,<br />
      티켓은 복원이 불가능하오니 사용은 반드시 현장직원만 진행해 주십시오.
    </div>`;

    const modalMsg = useTicketStateMessage || message;
    const modalBtns = this.useGroupBtns(!useTicketStateMessage);

    return (
      <div className={`App-modal ${isOpenModal ? 'modal-open' : null}`}>
        <div className="box-modal">
          <p className="txt-modal" dangerouslySetInnerHTML={ {__html: modalMsg} } />
          {modalBtns}
        </div>
      </div>
    )
  }

  render() {
    const {
      getAvailableTickets
    } = this.props.ticketStore;

    const ticketListInfo = getAvailableTickets();
    if(ticketListInfo.allChecked) {
      return this.renderAllSelectedPopup();
    } else {
      return this.renderReselectedPopup();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TicketModal.jsx